// Radar de retorno (dados abertos do CIOT, gravados no banco pelo robô
// mensal): o que sai de uma cidade e da região, e as cidades de cada UF.
// Precisa de internet.
import { executar, supabase } from '../supabase.js';

export async function radarDeRetorno({ cidade, uf, raioKm = 50, ufCasa = null }) {
  return executar(supabase.rpc('radar_de_retorno', { p_cidade: cidade, p_uf: uf, p_raio_km: raioKm, p_uf_casa: ufCasa }));
}

export async function kmEmLinhaReta({ origem, ufOrigem, destino, ufDestino }) {
  return executar(supabase.rpc('radar_km', { p_origem: origem, p_uf_origem: ufOrigem, p_destino: destino, p_uf_destino: ufDestino }));
}

const cidadesPorUf = new Map();
export async function cidadesDaUf(uf) {
  if (!uf) return [];
  if (!cidadesPorUf.has(uf)) {
    const pedido = executar(supabase.rpc('radar_cidades', { p_uf: uf })).then((linhas) => (linhas ?? []).map((l) => l.nome));
    cidadesPorUf.set(uf, pedido);
    pedido.catch(() => cidadesPorUf.delete(uf));
  }
  return cidadesPorUf.get(uf);
}

// A estrada é mais comprida que a linha reta (lib/geo.js).
export { FATOR_DA_ESTRADA, kmEstimado } from './geo.js';

// Nomes curtos dos tipos de carga (posição do NCM) que mais aparecem no CIOT.
const NOMES_CURTOS = {
  '00.01': 'Sem o tipo informado',
  '01.02': 'Gado vivo',
  '01.03': 'Porcos vivos',
  '01.05': 'Aves vivas',
  '02.01': 'Carne bovina',
  '02.02': 'Carne bovina congelada',
  '02.03': 'Carne suína',
  '02.07': 'Carne de frango',
  '03.03': 'Peixe congelado',
  '04.01': 'Leite',
  '04.07': 'Ovos',
  '07.01': 'Batata',
  '08.03': 'Banana',
  '09.01': 'Café',
  '10.01': 'Trigo',
  '10.05': 'Milho',
  '10.06': 'Arroz',
  '11.01': 'Farinha de trigo',
  '12.01': 'Soja',
  '15.07': 'Óleo de soja',
  '17.01': 'Açúcar',
  '19.05': 'Pães e biscoitos',
  '22.01': 'Água mineral',
  '22.02': 'Refrigerantes e águas',
  '22.03': 'Cerveja',
  '22.07': 'Álcool (etanol)',
  '23.04': 'Farelo de soja',
  '23.09': 'Ração',
  '24.01': 'Fumo',
  '25.05': 'Areia',
  '25.17': 'Brita e cascalho',
  '25.20': 'Gesso',
  '25.21': 'Calcário',
  '25.23': 'Cimento',
  '26.01': 'Minério de ferro',
  '27.10': 'Combustíveis (diesel, gasolina)',
  '27.11': 'Gás (GLP)',
  '30.04': 'Remédios',
  '31.02': 'Adubo nitrogenado (ureia)',
  '31.04': 'Adubo potássico',
  '31.05': 'Adubos e fertilizantes',
  '34.02': 'Produtos de limpeza',
  '39.01': 'Plástico em grão',
  '40.11': 'Pneus',
  '44.03': 'Madeira em tora',
  '44.07': 'Madeira serrada',
  '47.03': 'Celulose',
  '52.01': 'Algodão',
  '68.10': 'Peças de cimento (blocos, tubos)',
  '69.04': 'Tijolos',
  '69.07': 'Pisos e revestimentos cerâmicos',
  '69.08': 'Pisos e revestimentos cerâmicos',
  '70.10': 'Garrafas e potes de vidro',
  '72.08': 'Chapas de aço',
  '72.14': 'Barras de aço',
  '73.08': 'Estruturas de aço',
  '84.29': 'Máquinas de terraplanagem',
  '87.03': 'Carros',
  '87.04': 'Caminhões e utilitários',
  '87.08': 'Peças de veículos',
  '87.11': 'Motos',
  '94.03': 'Móveis',
};

// O nome que o app mostra: o curto, ou o do NCM até o primeiro ";".
export function nomeDaCarga(ncm, descricao) {
  if (NOMES_CURTOS[ncm]) return NOMES_CURTOS[ncm];
  const oficial = String(descricao ?? '').split(';')[0].trim();
  if (oficial) return oficial.length > 60 ? `${oficial.slice(0, 57).trim()}…` : oficial;
  return `NCM ${ncm}`;
}
